import {
  fetchSignIn,
  fetchSignOut,
  fetchChangePassword,
  fetchParameters,
  setFiltersDispatch,
  setRoleSelectedDispatch,
  authUser,
  cleanUpAuth,
  cleanUpPassword,
  cleanUpMessageAuth,
  fetchParametersNoLoader
} from 'state-managament/auth.slice';

import { useDispatch, useSelector } from 'react-redux';
import { getToken, getRememberMe } from "utils";


export default function useUser () {
  const { user, isSignedIn, error, roles, roleSelected, success, isLoaded, parameters, filters  } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const signIn = (data, keepSignedIn) => dispatch(fetchSignIn(data, keepSignedIn));
  const editPassword = (query) => dispatch(fetchChangePassword(query))
  const auth = (token, keepSignedIn) => dispatch(authUser({ token: getToken(), keepSignedIn: getRememberMe() }));
  const initParameters = (data) => dispatch(fetchParametersNoLoader(data));

  const cleanUp = () => dispatch(cleanUpAuth());
  const cleanPassword = () => dispatch(cleanUpPassword());
  const cleanUpMessage = () => dispatch(cleanUpMessageAuth());
  const signOut = () => dispatch(fetchSignOut());

  const setRoleSelected = (args) => dispatch(setRoleSelectedDispatch(args));
  const setFilters = (args) => dispatch(setFiltersDispatch(args));

  return {
    user,
    auth,
    signIn,
    signOut,
    initParameters,
    parameters,
    isSignedIn,
    error,
    success,
    setFilters,
    filters,
    isLoaded,
    cleanUp,
    editPassword,
    cleanPassword,
    cleanUpMessage,
    roles,
    roleSelected,
    setRoleSelected
  }
}
